import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback } from 'reactstrap';

var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1;
var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd
}
if (mm < 10) {
    mm = '0' + mm
}
today = yyyy + '-' + mm + '-' + dd;

export const Page2Address = ({ errors, touched, values, state, props, onProvinceChange, onResidentialProvinceChange,
     setFieldValue, onResidentIdemIdentity, requestResidentialCities }) => (
    <React.Fragment>
        <FormGroup>
            <legend>Alamat Tempat Tinggal/Korespondensi</legend>
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>Alamat<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="ResidentialAddressLine1" bsSize="sm" invalid={errors.ResidentialAddressLine1 && touched.ResidentialAddressLine1} maxLength={40}
                        />
                        {errors.ResidentialAddressLine1 && touched.ResidentialAddressLine1 ? (
                            <FormFeedback>{errors.ResidentialAddressLine1}</FormFeedback>
                        ) : null}

                        <Input tag={Field} name="ResidentialAddressLine2" bsSize="sm" invalid={errors.ResidentialAddressLine2 && touched.ResidentialAddressLine2} maxLength={40}
                        />
                        {errors.ResidentialAddressLine2 && touched.ResidentialAddressLine2 ? (
                            <FormFeedback>{errors.ResidentialAddressLine2}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Negara<span className="text-danger">*</span></Label>
                        <Field component="select" name="ResidentialAddressCountry" disabled
                            className={errors.ResidentialAddressCountry && touched.ResidentialAddressCountry ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            <option value="ID">Indonesia</option>
                        </Field>
                        {errors.ResidentialAddressCountry && touched.ResidentialAddressCountry ? (
                            <FormFeedback>{errors.ResidentialAddressCountry}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Provinsi<span className="text-danger">*</span> </Label>
                        <Field component="select" name="ResidentialAddressprovinceId"
                            className={errors.ResidentialAddressprovinceId && touched.ResidentialAddressprovinceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onResidentialProvinceChange(e, setFieldValue)}
                            disabled={values.ResidentialAddressIdem}
                        >
                            <option value="">-- Pilih --</option>
                            {props.provinces.map((province, i) =>
                                <option key={i} value={province.Id}>{province.Name}</option>
                            )}
                        </Field>
                        {errors.ResidentialAddressprovinceId && touched.ResidentialAddressprovinceId ? (
                            <FormFeedback>{errors.ResidentialAddressprovinceId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>City<span className="text-danger">*</span></Label>
                        <Field component="select" name="ResidentialAddressCityId"
                            className={errors.ResidentialAddressCityId && touched.ResidentialAddressCityId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            disabled={values.ResidentialAddressIdem}
                        >
                            <option value="">-- Pilih --</option>
                            {props.residentialCities ? props.residentialCities.map((city, i) =>
                                <option key={i} value={city.Id}>{city.Name}</option>
                            ) : null}
                        </Field>
                        {errors.ResidentialAddressCityId && touched.ResidentialAddressCityId ? (
                            <FormFeedback>{errors.ResidentialAddressCityId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
            <Col md="2">
                    <FormGroup>
                        <Label>RT<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="ResidentialAddressRT" type="number" bsSize="sm" maxLength="3" invalid={errors.ResidentialAddressRT && touched.ResidentialAddressRT} />
                        {errors.ResidentialAddressRT && touched.ResidentialAddressRT ? (
                            <FormFeedback>{errors.ResidentialAddressRT}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>RW<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="ResidentialAddressRW" type="number" bsSize="sm" maxLength="3" invalid={errors.ResidentialAddressRW && touched.ResidentialAddressRW} />
                        {errors.ResidentialAddressRW && touched.ResidentialAddressRW ? (
                            <FormFeedback>{errors.ResidentialAddressRW}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>Kode Pos<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="tel" maxLength={5} name="ResidentialAddressPostalCode" bsSize="sm"
                            invalid={errors.ResidentialAddressPostalCode && touched.ResidentialAddressPostalCode}
                            readOnly={values.ResidentialAddressIdem}
                        />
                        {errors.ResidentialAddressPostalCode && touched.ResidentialAddressPostalCode ? (
                            <FormFeedback>{errors.ResidentialAddressPostalCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
        </FormGroup>
        <FormGroup>
            <legend>Data Kontak</legend>
            {/* <Row>
                <Col md="6">
                    <FormGroup>
                        <Label>Nama Ahli Waris<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="HeirName" bsSize="sm" invalid={errors.HeirName && touched.HeirName} />
                        {errors.HeirName && touched.HeirName ? (
                            <FormFeedback>{errors.HeirName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="6">
                    <FormGroup>
                        <Label>Hubungan Ahli Waris<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="HeirRelation" bsSize="sm" invalid={errors.HeirRelation && touched.HeirRelation} />
                        {errors.HeirRelation && touched.HeirRelation ? (
                            <FormFeedback>{errors.HeirRelation}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row> */}
            <Row>
                <Col md="2">
                    <FormGroup>
                        <Label>Kode Area<span className="text-danger">*</span></Label>
                        <Input tag={Field} placeholder="(cth. 021xx)" type="text" maxLength="4" name="HomePhoneAreaCode" bsSize="sm"
                            invalid={errors.HomePhoneAreaCode && touched.HomePhoneAreaCode} />
                        {errors.HomePhoneAreaCode && touched.HomePhoneAreaCode ? (
                            <FormFeedback>{errors.HomePhoneAreaCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>No Telp Rumah<span className="text-danger">*</span></Label>
                        <Row>
                            <Col md="4"></Col>
                            <Input tag={Field} name="HomePhone" bsSize="sm" type="string" invalid={errors.HomePhone && touched.HomePhone} />
                            {errors.HomePhone && touched.HomePhone ? (
                                <FormFeedback>{errors.HomePhone}</FormFeedback>
                            ) : null}
                        </Row>
                    </FormGroup>
                </Col>
             
            </Row>
        
        </FormGroup>
        {/* END: Data Alamat */}
    </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/PengkinianData/Page2Address.js